import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DateTimeHelper from '../../../../../helpers/date-time-helper';
import StringHelper from '../../../../../helpers/string-helper';

const WRAP = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '0.625rem 0 0.75rem',
  borderBottom: '2px solid #555555',
  marginBottom: '0.625rem',
};

const DATE_BLOCK = {
  flex: 1,
  textAlign: 'center',
};

const LABEL_STYLE = {
  margin: 0,
  fontSize: '0.7rem',
  color: '#000',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.07em',
};

const DATE_STYLE = {
  margin: '3px 0 0',
  fontSize: '0.82rem',
  fontWeight: 700,
  color: '#555',
};

const ARROW_STYLE = {
  color: '#000',
  fontWeight: 700,
  fontSize: '0.9rem',
  flexShrink: 0,
};

const CheckoutSummaryHeader = props => {
  const { t } = useTranslation();
  const { arrival, departure } = props;

  return (StringHelper.isNotEmpty(arrival)) ? (
    <div style={WRAP}>
      <div style={DATE_BLOCK}>
        <p style={LABEL_STYLE}>Check-in</p>
        <p style={DATE_STYLE}>{DateTimeHelper.toDisplay(arrival, t)}</p>
      </div>
      <span style={ARROW_STYLE}>→</span>
      <div style={DATE_BLOCK}>
        <p style={LABEL_STYLE}>Check-out</p>
        <p style={DATE_STYLE}>{DateTimeHelper.toDisplay(departure, t)}</p>
      </div>
    </div>
  ) : '';
};

CheckoutSummaryHeader.propTypes = {
  arrival: PropTypes.string.isRequired,
  departure: PropTypes.string.isRequired,
};

export default CheckoutSummaryHeader;
